import { render, staticRenderFns } from "./Enquiries.vue?vue&type=template&id=7c1c6faa&scoped=true&"
import script from "./Enquiries.vue?vue&type=script&lang=js&"
export * from "./Enquiries.vue?vue&type=script&lang=js&"
import style0 from "./Enquiries.vue?vue&type=style&index=0&id=7c1c6faa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1c6faa",
  null
  
)

export default component.exports